var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import EnvironmentService from "../EnvironmentService.js";
import { newGuid } from "../GuidHelper.js";
import { HostService } from "../HostService.js";
class ApplicationInsightsLogProvider {
  constructor(appInsightsInstance, standardLoggingPropertiesProvider) {
    __publicField(this, "appInsights");
    this.appInsights = appInsightsInstance || window["appInsights"];
    if (!this.appInsights) {
      throw new Error("App insights was not initialized properly");
    }
    const addTelemetryInitializer = () => {
      this.appInsights.addTelemetryInitializer((envelope) => {
        let telemetryItem = envelope.baseData;
        telemetryItem.properties = telemetryItem.properties || {};
        const clientTime = performance.now();
        telemetryItem.properties["clientTime"] = clientTime;
        if (standardLoggingPropertiesProvider) {
          const standardLoggingProperties = standardLoggingPropertiesProvider();
          telemetryItem.properties = __spreadProps(__spreadValues(__spreadValues({}, telemetryItem.properties), standardLoggingProperties), {
            // It is unclear if there is a unique id associated with each log entry in Applicatoins Insights
            // Explicitly add one here so we can easily de-dup duplicate log entries
            uniqueLogEntryId: newGuid(),
            deviceid: HostService.getDeviceID,
            versionOverride: HostService.expUxVersionOverride,
            // @ts-ignore
            timeSincePageView: clientTime - standardLoggingProperties.routeViewTime,
            appSurface: "ExpUx"
          });
        }
      });
    };
    if (!!this.appInsights.addTelemetryInitializer) {
      addTelemetryInitializer();
    } else if (!!this.appInsights.snippet.queue) {
      this.appInsights.snippet.queue.push(addTelemetryInitializer);
    } else {
      this.appInsights.trackTrace(
        {
          message: "failed to AddTelemetryInitializer, neither appInsights.context or appInsights.queue exist",
          severityLevel: SeverityLevel.Error
        },
        {
          url: window.location.href,
          appInsights: this.appInsights
        }
      );
    }
    EnvironmentService.onUserChanged(() => {
      this.appInsights.setAuthenticatedUserContext(EnvironmentService.getUser().oid);
    });
    this.appInsights.setAuthenticatedUserContext(EnvironmentService.getUser().oid);
  }
  warn(event) {
    this.appInsights.trackTrace({ message: event.message, severityLevel: SeverityLevel.Warning }, event.properties);
  }
  info(event) {
    this.appInsights.trackTrace({ message: event.message, severityLevel: SeverityLevel.Information }, event.properties);
  }
  log(event) {
    this.appInsights.trackTrace({ message: event.message, severityLevel: SeverityLevel.Verbose }, event.properties);
  }
  error(event) {
    this.appInsights.trackTrace({ message: event.message, severityLevel: SeverityLevel.Error }, event.properties);
  }
  exception(error) {
    var _a, _b;
    const flattenResult = this.flatten(__spreadValues({
      errorId: error.id,
      errorStack: (_a = error == null ? void 0 : error.error) == null ? void 0 : _a.stack,
      errorMessage: (_b = error == null ? void 0 : error.error) == null ? void 0 : _b.message
    }, error.properties));
    this.appInsights.trackException({ exception: error.error, properties: flattenResult.properties });
    this.checkAndThrowErrors("trackException", flattenResult.stringifyFailureOccur, flattenResult.stringifyFailure);
  }
  pageView(pageView) {
    this.appInsights.trackPageView(pageView);
  }
  trackEvent(event) {
    this.appInsights.trackEvent(event);
  }
  trackMetric(metric) {
    this.appInsights.trackMetric(metric);
  }
  trackDependency(dependency) {
  }
  flatten(errorObj) {
    let properties = {};
    let stringifyFailureOccur = false;
    let stringifyFailure = null;
    Object.keys(errorObj).forEach((key) => {
      let v = errorObj[key];
      if (typeof v === "object") {
        try {
          properties[key] = JSON.stringify(v);
        } catch (e) {
          stringifyFailureOccur = true;
          stringifyFailure = e;
        }
      } else {
        properties[key] = v;
      }
    });
    return { properties, stringifyFailureOccur, stringifyFailure };
  }
  checkAndThrowErrors(name, stringifyFailureOccur, stringifyFailure) {
    if (stringifyFailureOccur) {
      throw new Error(`Stringify failed for properties of ${name} for ${stringifyFailure}`);
    }
  }
}
export {
  ApplicationInsightsLogProvider
};
//# sourceMappingURL=ApplicationInsightsLogProvider.js.map
